/*
 * NOVATIZE - Fullwidth banner responsive visibility
 * Shopify's slideshow component only fully excludes slides when the `hidden`
 * attribute is present. We mirror the block hide settings into `hidden` on the
 * active breakpoint so hidden banner blocks disappear from both the UI and the
 * slideshow navigation state.
 */
const DESKTOP_MEDIA_QUERY = '(min-width: 750px)';
const VISIBILITY_SELECTOR = 'slideshow-slide[data-fullwidth-banner-visibility]';

function updateSlideshowState(slideshow) {
  if (!(slideshow instanceof HTMLElement) || typeof slideshow.select !== 'function') return;

  const visibleSlides = slideshow.slides || [];
  const currentSlide = visibleSlides[slideshow.current];

  if (currentSlide instanceof HTMLElement && !currentSlide.hasAttribute('hidden')) return;
  if (!visibleSlides.length) return;

  const nextVisibleSlide = visibleSlides[0];
  const slideIndex = slideshow.refs?.slides?.indexOf(nextVisibleSlide) ?? 0;

  slideshow.setAttribute('initial-slide', `${slideIndex}`);
  slideshow.select(slideIndex, undefined, { animate: false });
}

function updateSlideVisibility(root = document) {
  const isDesktop = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
  const slides = root.querySelectorAll(VISIBILITY_SELECTOR);

  slides.forEach((slide) => {
    const hideOnMobile = slide.getAttribute('data-hide-on-mobile') === 'true';
    const hideOnDesktop = slide.getAttribute('data-hide-on-desktop') === 'true';
    const shouldHide = isDesktop ? hideOnDesktop : hideOnMobile;

    if (shouldHide) {
      slide.setAttribute('hidden', '');
      slide.setAttribute('aria-hidden', 'true');
    } else {
      slide.removeAttribute('hidden');
    }

    updateSlideshowState(slide.closest('slideshow-component'));
  });
}

const runUpdate = () => updateSlideVisibility();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runUpdate, { once: true });
} else {
  runUpdate();
}

window.addEventListener('resize', runUpdate, { passive: true });
document.addEventListener('shopify:section:load', runUpdate);
document.addEventListener('shopify:section:reorder', runUpdate);
document.addEventListener('shopify:block:select', runUpdate);
